import { Component, OnInit, Input } from '@angular/core';
import { EvenementWebhook } from 'src/api/models';

@Component({
  selector: 'app-webhook-evenement',
  templateUrl: './webhook-evenement.component.html',
  styleUrls: ['./webhook-evenement.component.css']
})
export class WebhookEvenementComponent implements OnInit {

  @Input('id') public id: number;

  constructor() { }

  ngOnInit(): void {
  }

  GetWebhookEvenement(e: EvenementWebhook) {
    return EvenementWebhook[e];
  }  
}
